import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconTriangle } from 'src/assets/icons/IconTriangle';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

export const DirectionalTriangleIcon = ({ className, direction, ...restProps }) => {
  const styles = useStyles({ direction });
  return (
    <IconTriangle
      className={cx(styles.root, className)}
      {...restProps}
    />
  );
};

DirectionalTriangleIcon.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(ROTATE_DIRECTION)),
};
DirectionalTriangleIcon.defaultProps = {
  className: '',
  direction: ROTATE_DIRECTION.right,
};
